export const generalPublicDetails = {
  name: 'General Public',
  tin: 'EI00000000010',
  registration_number: 'NA',
  address1: 'NA',
  address2: '',
  address3: '',
  email: null,
  phone: 'NA',
  postal_code: 'NA',
  country_code: 'MYS',
  registration_type: 'PASSPORT',
  sst_registration_number: 'NA',
  state: '17',
  city: 'NA',
};
